import React, { useState } from 'react'
import axios from 'axios'

import Caixa from '../TermoVisita/ModulosCrefito/Caixa'
import HeaderVerde from '../TermoVisita/ModulosCrefito/HeaderVerde'

import Cidades from '../Cidades/Cidades.js'

const RotaNaoRealizada = () => {
    const [ficha, setFicha] = useState({
        estabelecimento: "", endereco: "", data: "", estado: "", 
        municipio: "", situacao: "", user: localStorage.nome
    })
    const [municipios, setMunicipios] = useState([])

    const updateField = (e) => {
        const { name, value } = e.target
        let update = { ...ficha }
        update[name] = value
        setFicha(update)
        if (name === "estado") {
            let cidades = Cidades[value]
            setMunicipios(cidades)
        }
    }
    
    const updateFile = (e) => {
        const { name } = e.target
        let update = { ...ficha }
        let file = e.target.files[0]
        update[name] = file
        setFicha(update)
    }

    const enviar = () => {
        const formData = new FormData()
        formData.append("file", ficha.file)
        formData.append("estabelecimento", ficha.estabelecimento)
        formData.append("endereco", ficha.endereco)
        formData.append("data", ficha.data)
        formData.append("estado", ficha.estado)
        formData.append("municipio", ficha.municipio)
        formData.append("situacao", ficha.situacao)
        formData.append("user", ficha.user)

        const url = `/api/rotaNaoRealizada/save`
        axios.post(url, formData)
            .then(res => {
                if(res.data.message) alert(res.data.message)
                else {
                    alert(res.data)
                    window.location = `/`
                }
            })
            .catch(error => alert(error.message))
    }
   
    const styles = {
        principal: {
            display: "inline-grid",
            textAlign: "left", color: "#484848", marginTop: "2vh"
        },
        input: {
            width: "80vw", backgroundColor: "#00000000", border: "1px solid #00000029",
            borderRadius: "5px", minHeight: "5px"
        }
    }

    return (
        <Caixa>
            <HeaderVerde texto="FISCALIZAÇÃO NÃO REALIZADA" />
            <div style={{ textAlign: "left" }}>
                <div style={styles.principal}>
                    <div>Estabelecimento</div>
                    <input type="text" style={styles.input} name="estabelecimento"
                        onChange={e => updateField(e)} />
                </div>
                <div style={styles.principal}>
                    <div>Endereço</div>
                    <input type="text" style={styles.input} name="endereco" onChange={e => updateField(e)} />
                </div>
                <div style={styles.principal}>
                    <div>Data</div>
                    <input type="date" style={{ ...styles.input, width: "18vw" }} name="data"
                        onChange={e => updateField(e)} />
                </div>
                <div style={{ ...styles.principal, marginLeft: "2vw" }}>
                    <div>Estado</div>
                    <select type="text" style={{ ...styles.input, width: "18vw" }} name="estado"
                        onChange={e => updateField(e)} >
                        <option value=""></option>
                        <option value="AL">AL</option>
                        <option value="PB">PB</option>
                        <option value="PE">PE</option>
                        <option value="RN">RN</option>
                    </select>
                </div>
                <div style={{ ...styles.principal, marginLeft: "2vw" }}>
                    <div>Município</div>
                    <select type="text" style={{ ...styles.input, width: "18vw" }} name="municipio"
                        onChange={e => updateField(e)} >
                        <option value=""></option>
                        {RenderOptions()}
                    </select>
                </div>
                <div style={{ ...styles.principal, marginLeft: "2vw" }}>
                    <div>Situação</div>
                    <select type="text" style={{ ...styles.input, width: "18vw" }} name="situacao"
                        onChange={e => updateField(e)} >
                        <option value=""></option>
                        <option value="Fechado">Fechado</option>
                        <option value="Desativado">Desativado</option>
                        <option value="Endereço não encontrado">Endereço não encontrado</option>
                    </select>
                </div>
                <HeaderVerde texto="Anexar Imagem" />
                <input type="file" style={{ ...styles.input, width: "40vw" }} name="file"
                        onChange={e => updateFile(e)} />
            </div>
            <button className='btn btn-success mt-4' onClick={e => enviar()}>Enviar</button>
        </Caixa>
    )

    function RenderOptions() {
        let options = []
        municipios.map(cidade => {
            options.push(
                <option value={cidade.nome}>{cidade.nome}</option>
            )
        })
        return options
    }
}

export default RotaNaoRealizada